// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconUserCheck, IconBasket, IconMessages,
     IconLayoutKanban, IconMail, IconCalendar, IconNfc,
      IconUserCircle,
      IconUserScreen
    } from "@tabler/icons-react"

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

// ==============================|| APPLICATION MENU ITEMS ||============================== //

const etudiants = {
    id: 'student',
    title: <FormattedMessage id="menu_etudiant" />,
    type: 'group',
    icon: <IconUserScreen />, // Use a valid icon component here

    children: [
       //  {
           /*  id: 'funcoes2',
            title: <FormattedMessage id="gestion_etudiants" />,
            type: 'collapse',
            icon: icons.IconUserCheck,
            children: [ */

            
           /*  {
                id: 'donninscription1',
                title: ['1. ', <FormattedMessage id="donnees_inscription" />],
                type: 'item',
                url: '/portailEtudiant/Matriculas',
            }, */
            
                {
                    id: 'donninscription1',
                    title: ['1. ', <FormattedMessage id="donnees_inscription" />],
                    type: 'item',
                    url: '/portailEtudiant/Matriculas',
                },

                {
                    id: 'horarioEstudante',
                    title: ['2. ',<FormattedMessage id="horarioDoEstudante" />],
                    type: 'item',
                    url: '/portailEtudiant/HorarioDoEstudanteStudents',
                },

                {
                    id: 'soldefinancier1',
                    title: ['3. ',<FormattedMessage id="solde_financier" />],
                    type: 'item',
                    url: '/portailEtudiant/SaldoEstudanteStudent',
                    // breadcrumbs: true
                },

                {
                    id: 'donnees_paiement_frais1',
                    title: ['4. ', <FormattedMessage id="donnees_paiement_frais" />],
                    type: 'item',
                    url: '/portailEtudiant/PaiementDesFraisEtudiant',
                    // breadcrumbs: true
                },

                {
                    id: 'releveNote',
                    title: ['5. ',<FormattedMessage id="bulletin_de_points" />],
                    type: 'item',
                    url: '/portailEtudiant/ReleveCoteImpressionEtudiantApi',
                    // breadcrumbs: true
                },

                {
                    id: 'extraitEtudiant',
                    title: ['6. ',<FormattedMessage id="extrait_compite_etudia" />],
                    type: 'item',
                    url: '/portailEtudiant/ExtraitCommpteEtudiantApi',
                    // breadcrumbs: true
                },

                {
                    id: 'cours_optionnel_addicionner1',
                    title: ['7. ',<FormattedMessage id="cours_optionnel_addicionner" />],
                    type: 'item',
                    url: '/portailEtudiant/coursOptionnelEtudiantApi',
                    // breadcrumbs: true
                },

                {
                    id: 'coursPlan1',
                    title: ["8. ",<FormattedMessage id="plandu_cours" />],
                    type: 'item',
                    url: '/portailEtudiant/coursPlanStudent'
                },

                {
                    id: 'messagerie_et_email1',
                    title: ['9. ', <FormattedMessage id="messagerie_et_email" />],
                    type: 'item',
                    url: '#',
                    // breadcrumbs: true
                },

                {
                    id: 'salle_virtuelle1',
                    title: ['10. ', <FormattedMessage id="salle_virtuelle" />],
                    type: 'item',
                    url: '/portailEtudiant/ClasseVirtuelle',
                    breadcrumbs: true
                },
                {
                    id: 'declaracoes_et_diplomes1',
                    title: ['11. ', <FormattedMessage id="declaracoes_et_diplomes" />],
                    type: 'item',
                    url: '/portailEtudiant/DeclarationsEDiplome',
                    // breadcrumbs: true

                },

            
           // ]
       // }
    ]
};

export default etudiants;
